import { render } from "./SummaryNavigation.vue?vue&type=template&id=54152cc6"
import script from "./SummaryNavigation.vue?vue&type=script&lang=js"
export * from "./SummaryNavigation.vue?vue&type=script&lang=js"

import "./SummaryNavigation.vue?vue&type=style&index=0&id=54152cc6&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__